import type { BottegasRinascentePageProps } from '@components/BottegasRinascente/BottegasRinascentePage'
import { createAppFromCommonTemplate, lazyImport } from '@helpers'
import { parseJSONSafe } from '@velasca/utils/parse-json-safe'

const { BottegasRinascentePage } = lazyImport(
  () => import('@components/BottegasRinascente/BottegasRinascentePage'),
  'BottegasRinascentePage',
)

export const renderBottegasRinascenteApp = () => {
  const allBottegaRinascenteEl = document.getElementById(
    'all-bottega-rinascente',
  )
  const allBottegaRinascenteJsonEl = document.getElementById(
    'all-bottega-rinascente-json',
  )
  const bottegasRinascenteJson: BottegasRinascentePageProps =
    allBottegaRinascenteJsonEl
      ? parseJSONSafe(allBottegaRinascenteJsonEl.innerText)
      : {}

  createAppFromCommonTemplate(
    allBottegaRinascenteEl,
    <BottegasRinascentePage {...bottegasRinascenteJson} />,
  )
}
